import { subscriptionPixCheckoutEnabled } from "@/domains/subscription/billingHelpers";

export const MarketplaceModuleSlugs = {
    finance: "finance",
    secretary: "secretary",
    aiReports: "aiReports",
} as const;

export type MarketplaceModuleSlug = (typeof MarketplaceModuleSlugs)[keyof typeof MarketplaceModuleSlugs];

export type ModuleEntitlement = {
    active: boolean;
    source?: string | null;
    endsAt?: string | null;
};

export type UserModules = Partial<Record<MarketplaceModuleSlug, ModuleEntitlement>>;

export function isFinanceModuleActive(modules?: UserModules | null): boolean {
    return Boolean(modules?.finance?.active);
}

export function isSecretaryModuleActive(modules?: UserModules | null): boolean {
    return Boolean(modules?.secretary?.active);
}

export function isAiReportsModuleActive(modules?: UserModules | null): boolean {
    return Boolean(modules?.aiReports?.active);
}

/** Multi org: aiReports patient tab requires marketplace purchase, not base-plan bundle. */
export function isPurchasedOrgMarketplaceModule(
    modules: UserModules | null | undefined,
    slug: Extract<MarketplaceModuleSlug, "finance" | "aiReports">,
): boolean {
    const entitlement = modules?.[slug];
    if (!entitlement?.active) {
        return false;
    }

    return entitlement.source !== "bundled";
}

/** Pix Automático for Marketplace module checkout. Finance and Time administrativo remain card-only. */
export const marketplaceModulePixCheckoutEnabled: Record<MarketplaceModuleSlug, boolean> = {
    finance: false,
    secretary: false,
    aiReports: true,
};

export function isMarketplaceModulePixCheckoutEnabled(slug: MarketplaceModuleSlug): boolean {
    return subscriptionPixCheckoutEnabled && marketplaceModulePixCheckoutEnabled[slug];
}

export function isBundledPlanModuleSlug(slug: string): boolean {
    return slug === MarketplaceModuleSlugs.finance || slug === MarketplaceModuleSlugs.secretary;
}
